import React, { useEffect, useRef } from 'react';
import AppContainer from '@src/components/styled/AppContainer';

// socket
import { createSocket } from '@src/io/index';
import eventsIn from '@src/io/events_in';
// store
import { _useDispatch, _useSelector } from './state/hooks';
import { setIsConnected, setStage } from '@src/state/slices/slice_app';
import { Stage } from '@src/state/slices/types';
import { clearGamesState } from '@src/state/slices/slice_game';

// components
import AppViewController from '@src/components/AppViewController';
import { useAccount, WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { config } from '@src/wagmi';
import FullViewLoader from '@src/components/FullViewLoader';
import { ConnectKitProvider } from 'connectkit';
import { SANKO_CHAIN } from '@src/chains';

const queryClient = new QueryClient();

let socket = createSocket();
export const getSocket = () => {
  return socket;
};
export const setSocket = (newSocket: typeof socket) => {
  socket.disconnect();
  socket.close();
  socket.removeAllListeners();
  socket = newSocket;
};

function App() {
  const socketNonce = _useSelector((state) => state.app.socketNonce);

  const dispatch = _useDispatch();

  useEffect(() => {
    function onConnect() {
      dispatch(setIsConnected(true));
    }

    function onDisconnect() {
      dispatch(clearGamesState());
      dispatch(setIsConnected(false));
      dispatch(setStage({ stage: Stage.LOGIN, stageMeta: {} }));
    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    for (const event of eventsIn) {
      socket.on(event.event, event.getCallback());
    }
    return () => {
      console.log('CLEANING UP SOCKET');
      socket.disconnect();
      socket.close();
      socket.removeAllListeners();
    };
  }, [socketNonce]);

  function disconnectAndGoToLogin() {
    socket.disconnect();
  }

  return (
    <QueryClientProvider client={queryClient}>
      <WagmiProvider config={config}>
        <ConnectKitProvider
          theme='retro'
          options={{
            initialChainId: SANKO_CHAIN.id,
          }}
        >
          <AppContainer>
            {process.env.NODE_ENV === 'development' && (
              <button
                type='button'
                style={{ alignSelf: 'flex-start' }}
                onClick={disconnectAndGoToLogin}
              >
                Disconnect
              </button>
            )}
            <FullViewLoader />
            <AppViewController disconnect={disconnectAndGoToLogin} />
          </AppContainer>
        </ConnectKitProvider>
      </WagmiProvider>
    </QueryClientProvider>
  );
}

export default App;
